/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function(url) {
  return new Promise(resolve => {
    var img = new Image()
    img.onload = function() {
      if (this.complete == true) {
        resolve(true)
        img = null
      }
    }
    img.onerror = function() {
      resolve(false)
      img = null
    }
    img.src = url
  })
}

/**
 * src属性为默认地址，v-real-img绑定真实地址
 * <img
    src="defaultImg"
    v-real-img="data.avatar"/>
 */
export default {
  realImg: {
    async bind(el, binding) {
      let imgURL = binding.value //获取图片真实地址
      if (imgURL) {
        let exist = await imageIsExist(imgURL)
        if (exist) {
          el.setAttribute('src', imgURL)
        }
      }
    }
  }
}
